<template>
  <a-modal
    class="contact-modal-wrapper"
    width="702px"
    :mask-closable="false"
    :visible="visible"
    :title="title"
    :confirm-loading="btnIsLoading"
    @ok="$emit('handleSubmit')"
    @cancel="$emit('onCancel')"
  >
    <basic-form
      ref="basicForm"
      :form-data="formData"
    >
      <template #parent_id>
        <a-select
          v-decorator="[
            'parent_id',
            { rules: [{ required: true }] },
          ]"
          :disabled="disabled"
        >
          <a-select-option
            v-for="item in typeData"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </template>
      <template #name>
        <a-input
          v-decorator="['name',{rules: [
            { required: true, message: '请输入分类名称' },
          ],}]"
          placeholder="请输入分类名称"
        />
      </template>
      <template #list_order>
        <a-input-number
          v-decorator="['list_order',{rules: [
            { required: true, message: '请输入排序' },
          ],}]"
          placeholder="请输入排序"
          style="width:100%"
        />
      </template>
    </basic-form>
  </a-modal>
</template>
<script>
import {
  formData,
} from '../data/index';
export default{
  props: ['title', 'visible', 'btnIsLoading', 'disabled'],
  data(){
    return{
      formData,
      loading: false,
      typeData: [{id: 0, name: '无'}],
    };
  },
  mounted(){
    this.getTableData();
  },
  methods: {
    // 递归处理
    dealData(data){
      data.forEach((item)=>{
        this.typeData.push({id: item.id, name: item.name});
        if(item.child_list){
          this.dealData(item.child_list);
        }
      });
    },
    // 获取表格数据
    async getTableData() {
      let result = await this.$http.post('/department/adminGetList');
      console.log('TCL: getTableData -> result', result);
      if (result.data.status===1) {
        let data = result.data.data.data_list;
        this.dealData(data);
        console.log('TCL: getTableData -> this.typeData', this.typeData);

      }
    },
  },
};
</script>
<style lang="less" scoped>

</style>